import ArticleLayout from '../article/components/ArticleLayout';
import { articles } from '@/mocks/articles';

export default function DostawaPage() {
  return <ArticleLayout article={articles[2]} />;
}